import React from "react";
import {
  Layout,
  Welcome,
  About,
  Education,
  Experience,
  Skills,
} from "../components";
import { useWindowSize } from "../util";

function Home() {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width <= 600;
  return (
    <Layout>
      <Welcome isMobile={isMobile} />
      <About isMobile={isMobile} />
      <Education
        scrollThreshold={1.2 * windowSize.height}
        isMobile={isMobile}
      />
      <Experience scrollThreshold={2 * windowSize.height} isMobile={isMobile} />
      <Skills scrollThreshold={3 * windowSize.height} isMobile={isMobile} />
    </Layout>
  );
}

export default Home;
